export enum AnnouncementStatus
{
    New = 1,
    Pending,
    Completed,
    Failed
};